module.exports = __webpack_public_path__ + "img/go_reco_small.5d27929e.svg";